<template>
    <div class="content" v-if="products && products.length > 0">
        <h2 :class="{'section-title': stylizeTitle}">
            <i v-if="stylizeTitle" class="icon-cr icon-register"/>
            <span class="hidden-xs-down">
                <span v-if="$scope.CUSTOMER">{{ $scope.CUSTOMER.FIRST_NAME }},</span>
                Confira as últimas maravilhas vistas por você!
            </span>
            <span class="hidden-xs-up">Últimos vistos</span>
        </h2>
        <ProductList
            :products="products"
            :item-options="itemOptions"
            list-class="product-horizontal-list product-horizontal-list-8 no-scrollbar"
            event-name="Histórico de produtos"
            @scroll="scrollEvent = $event"/>
        <HorizontalScrollbar
            v-if="products.length > 2"
            class="hidden-not-touch"
            :scroll-event="scrollEvent"/>
    </div>
</template>

<script>
    import ProductList from "./ProductList";
    import {lazyLoadInstance} from "../../../common/common";
    import HorizontalScrollbar from "./container/HorizontalScrollbar";

    export default {
        name: "History",

        components: {HorizontalScrollbar, ProductList},

        props: {
            stylizeTitle: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                scrollEvent: null,
                products: null,
                itemOptions: {
                    hideInstallments: true,
                    displayPrice: false,
                    displayModel: false,
                    displayPercent: false,
                    displayName: false
                },
                sliderOptions: {
                    slidesPerView: 2,
                    enableBullets: true,
                    fitSlidesToParent: true,
                    onNavigate: () => lazyLoadInstance.update(),
                    responsive: [
                        {
                            minWidth: 768,
                            settings: {
                                slidesPerView: 4,
                            }
                        },
                        {
                            minWidth: 992,
                            settings: {
                                slidesPerView: 7,
                            }
                        },
                    ]
                }
            }
        },

        created() {
            this.fetch();
        },

        methods: {
            fetch() {
                this.axios.http.get("/history.php", {
                    params: {count: 7}
                }).then((response) => {
                    if (response.data.products) this.products = response.data.products.data;
                }).catch(error => console.error(error));
            },
        }
    }
</script>